import { randomBytes } from './crypto'

/** Crockford base32 alphabet — no I, L, O, U to avoid transcription errors. */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

/**
 * A recovery secret is the ONLY thing (besides the backup file) needed to
 * decrypt. 25 chars over a 32-symbol alphabet ≈ 125 bits of entropy. `% 32`
 * is unbiased because 256 is an exact multiple of 32.
 */
export function generateRecoverySecret(groups = 5, groupLen = 5): string {
  const bytes = randomBytes(groups * groupLen)
  const parts: string[] = []
  for (let g = 0; g < groups; g++) {
    let s = ''
    for (let i = 0; i < groupLen; i++) s += ALPHABET[bytes[g * groupLen + i] % ALPHABET.length]
    parts.push(s)
  }
  return parts.join('-')
}

export function looksLikeSecret(value: string): boolean {
  return value.trim().replace(/[\s-]/g, '').length >= 20
}
